import './style.less';
import { flatten } from 'lodash';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';

export default function($q, $log, $stateParams, $filter, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onChanges = init;

  vm.exportRegistrants = () => {
    let header = 'First, Last, Email, Attended, Completed \n';
    const body = vm.registrants
      .map(user => {
        return (
          `${checkProp(user.first).replace(/,/g, '.')}, ` +
          `${checkProp(user.last).replace(/,/g, '.')}, ` +
          `${checkProp(user.email).replace(/,/g, '.')}, ` +
          `${stringBoolean(user.attended)}, ` +
          `${stringBoolean(user.completed)}`
        );
      })
      .join('\n');
    const uri = 'data:text/csv;charset=utf-8,' + escape(`${header}${body}`);
    return uri;
  };

  vm.exportCertificates = () => {
    let header =
      'Date, Certificate, Sponsor, Delivery Method, Subject Area, First Name, Last Name, Email, Level, Departments, Locations, Practice Areas, PDF';
    const body = vm.certificates
      .map(cert => {
        let hours = '';
        let departments = '';
        let locations = '';
        let practice_areas = '';
        if (cert.hours)
          hours = cert.hours.map(({ subject_area, credits }) => `${subject_area}: ${credits}`).join(' + ');
        if (cert.departments) departments = cert.departments.join(' + ');
        if (cert.locations) locations = cert.locations.join(' + ');
        if (cert.practice_areas) practice_areas = cert.practice_areas.join(' + ');
        return (
          `${checkProp($filter('date')(cert.date, 'shortDate')).replace(/,/g, '.')},` +
          `${checkProp(cert.cert).replace(/,/g, '.')},` +
          `${getSponsor(cert)},` +
          `${getDeliveryMethod(cert.delivery_method).replace(/,/g, '.')},` +
          `${hours},` +
          `${checkProp(cert.first).replace(/,/g, '.')},` +
          `${checkProp(cert.last).replace(/,/g, '.')},` +
          `${checkProp(cert.email).replace(/,/g, '.')},` +
          `${checkProp(cert.level).replace(/,/g, '.')},` +
          `${departments},` +
          `${locations},` +
          `${practice_areas},` +
          `${cert.pdf}`
        );
      })
      .join('\n');
    const uri = 'data:text/csv;charset=utf-8,' + escape(`${header}\n${body}`);
    return uri;
  };

  vm.downloadPDFs = () => {
    const zip = new JSZip();
    const promises = vm.certificates
      .filter(({ pdf_uploaded }) => pdf_uploaded)
      .map(({ pdf, first, last, profile_uid }) => {
        return new Promise((resolve, reject) => {
          JSZipUtils.getBinaryContent(pdf, (error, data) => {
            if (error) reject(error);
            const uid = $filter('uppercase')($filter('limitTo')(profile_uid, 8));
            const fileName = `${first}-${last}-${uid}.pdf`;
            zip.file(fileName, data, { binary: true });
            resolve();
          });
        });
      });

    $q.all(promises)
      .then(() => zip.generateAsync({ type: 'blob' }))
      .then(content => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(content);
        downloadLink.download = `${vm.eventInfo.course_name}-PDFs.zip`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function init() {
    if (vm.event) {
      const event = vm.event;
      vm.eventInfo = event;
      vm.registrants = flatten(event.locations.map(({ attendees }) => attendees));
      vm.certificates = event.certs;
      vm.evaluations = { reviews: event.reviews, form: event.form };
      vm.evaluationsReportParams = { event_id: vm.event.event_id };
      vm.loaded = true;
    }
  }

  // Private Functions
  function checkProp(data) {
    if (data) return data;
    return '';
  }

  function getDeliveryMethod(data) {
    if (!data) return '';
    if (!data.name) return '';
    return data.name;
  }

  function getSponsor(cert) {
    if (!cert.sponsors || !cert.sponsors.name) return '';
    return cert.sponsors.name.replace(/,/g, '.');
  }

  function stringBoolean(bool) {
    if (bool) return 'Yes';
    return 'No';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/reports/controller.js